import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateWorkflowPermissionMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { usePermissionsContext } from '../../../PermissionsContext'
import { buildCreatePermissionInput } from '../../../utils'
import { PermissionFormValues, WorkflowPermissionRecord } from '../../../types'
import PermissionFormItems from '../components/PermissionFormItems'

export function useCreate(): CreateHeaderActionOptions<WorkflowPermissionRecord> {
  const { fetching, refetch, workflowId } = usePermissionsContext()
  const [createPermission, { loading: creating }] =
    useCreateWorkflowPermissionMutation(DefaultMutationHookOptions)

  return {
    entity: 'Permission',
    permission: 'admin',
    loading: fetching || creating,
    modal: {
      type: 'simple',
      width: 'wide',
      body: <PermissionFormItems />,
      onOk: async (values: PermissionFormValues) => {
        await createPermission({
          variables: {
            input: buildCreatePermissionInput(workflowId, values),
          },
        })
        await refetch()
        simpleCreateNotification('Permission')
      },
    },
  }
}
